import {
  Image
} from '@shopify/hydrogen';
import ButtonText from '../../assets/image/icons/whatsapp-icon.png';
import { useEffect, useState } from 'react';

export default function ButtonWs({origin}) {
  const opacity = true;
  const [scrollOn, setScrollOn] = useState(false);
  const [producDetailClass, setProductDetailClass] = useState('');
  const [scrollOr, setScrollOr] = useState('scollUp');
  const [offButton, setOffButton] = useState('');
  const [giftNote, setGiftNote] = useState('');
  const [cartZone, setCartZone] = useState('');


  const deleteButton = () => {
    if(origin=='globalButton'){
      try{
        const currentURL = window.location.href; 
        
        if(currentURL.indexOf('/cart') > 0){
          setOffButton('button-off');
        }else{
          setOffButton('');
        }
      }catch(e){}
    }
  }

  useEffect(() => {
    try{
      setTimeout(()=>{ deleteButton(); }, 2000);

      let scrollingTimer;
      const currentURL = window.location.href;    
      const handleScrollStopped = ()=>{
        setScrollOn(false)
      }
      
      let lastScrollTop = 0;

      window.addEventListener("scroll", () => {
        setScrollOn(true);

        clearTimeout(scrollingTimer);
        scrollingTimer = setTimeout(() => {
          handleScrollStopped();
        }, 250);

      });

      window.addEventListener("scroll", () => {
        const scrollTop = document.documentElement.scrollTop;
    
        if (scrollTop > lastScrollTop) {
          setScrollOr('scollUp')
        } else {
          setScrollOr('scollDown')
        }
      
        lastScrollTop = scrollTop;
      });

      //
      if(origin=='productDetail'){
        setProductDetailClass('product-detail-button')
        setOffButton('')
      }else if(origin=='globalButton'){
        deleteButton();
      }else if(origin=='giftNote'){
        setGiftNote('git-note-wts')
      }else if(origin=='cartZone'){
        setCartZone('cart-zone')
      }
    }catch(e){}
  },[])

  return (
    <></>
    // Remove WTS
    // <div className={`button-whatsaap-container ${producDetailClass} ${scrollOr} ${offButton} ${giftNote} ${cartZone}`}>
    //     <a href="https://wa.me/5215531489503" target="_blank">
    //       <Image
    //           src={ButtonText}
    //           width={64}
    //           height={64}
    //           alt="Whatsaap"
    //           className= {scrollOn ? "whatsaap opacity-button" : "whatsaap"}
    //       />
    //     </a>
    // </div>
  )
}